import React from 'react';

const Logo = ({ className = "h-10", iconOnly = false }) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {/* World-Class Geometric Prism Mark */}
      <div className="relative flex-shrink-0">
        <svg
          viewBox="0 0 40 40"
          className="w-10 h-10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Top Face - Precision Grid ( land analysis representation ) */}
          <path 
            d="M20 6L35 15L20 24L5 15L20 6Z" 
            fill="#0F172A" 
            fillOpacity="0.05" 
          />
          
          {/* Top Face Detail Grid Nodes */}
          <circle cx="20" cy="11" r="0.75" fill="#2563EB" fillOpacity="0.5" />
          <circle cx="15" cy="14" r="0.75" fill="#2563EB" fillOpacity="0.5" />
          <circle cx="25" cy="14" r="0.75" fill="#2563EB" fillOpacity="0.5" />
          <circle cx="20" cy="17" r="0.75" fill="#2563EB" fillOpacity="0.5" />
          
          {/* Left Face - Structural Foundation ( Development ) */}
          <path 
            d="M5 15V26L20 35V24L5 15Z" 
            fill="#0F172A" 
          />
          
          {/* Right Face - Analytical Intelligence ( Analysis ) */}
          <path 
            d="M20 24L35 15V26L20 35V24Z" 
            fill="#2563EB" 
          />
          
          {/* Center Spine Detail */}
          <path 
            d="M20 24V35" 
            stroke="white" 
            strokeWidth="0.5" 
            strokeOpacity="0.2" 
          />
        </svg>
      </div>

      {!iconOnly && (
        <div className="flex flex-col">
          <div className="flex items-baseline">
            <span className="text-xl font-black tracking-tight text-slate-900 leading-none">
              Development<span className="text-blue-600 ml-[1px]">Analyzer</span>
            </span>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <div className="h-[1px] w-2.5 bg-blue-600/30"></div>
            <span className="text-[9px] font-bold uppercase tracking-[0.45em] text-slate-400 whitespace-nowrap">
              Systems Intelligence
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
